import moment from 'moment'
import 'moment/locale/es'
import 'moment/locale/fr'
import { normalizeLocale } from 'civic-champs-translations/src'

const MOMENT_LOCALES = {
  en: 'en',
  es: 'es',
  fr: 'fr',
}

export function syncMomentLocale(language) {
  const locale = normalizeLocale(language)
  const momentLocale = MOMENT_LOCALES[locale] || MOMENT_LOCALES.en
  moment.locale(momentLocale)
}
